(function () {
  var root = document.querySelector("[data-b1p]");
  if (!root) return;

  var handle = root.getAttribute("data-handle");
  var catalogUrl = root.getAttribute("data-catalog-url");
  var customerId = root.getAttribute("data-customer-id") || "";

  var SLOT_LABELS = {
    strut: "Strut tower",
    coilover: "Coilovers",
    arm: "Control arms",
    mirrors: "Mirrors",
    shifter: "Shifter",
    paddles: "Paddles"
  };

  var CATEGORIES = [
    { name: "Suspension", slots: ["coilover", "arm"] },
    { name: "Chassis & Bracing", slots: ["strut"] },
    { name: "Brakes", slots: [] },
    { name: "Intake", slots: [] },
    { name: "Exhaust", slots: [] },
    { name: "Wheels", slots: [] }
  ];

  function profileKey() {
    return customerId ? "brace1-garage-profile-v1-" + customerId : "brace1-garage-profile-v1";
  }

  function readProfile() {
    try {
      return JSON.parse(localStorage.getItem(profileKey()) || "{}");
    } catch (err) {
      return {};
    }
  }

  function savedVehicle(profile) {
    if (profile.lastVehicle && profile.lastVehicle.make && profile.lastVehicle.model) {
      return profile.lastVehicle;
    }
    var builds = Object.values(profile.vehicleBuilds || {});
    if (!builds.length) return null;
    var latest = builds[builds.length - 1];
    if (latest && latest.make && latest.model) return latest;
    return null;
  }

  function vehicleLabel(vehicle) {
    if (!vehicle) return "";
    return [vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(" ");
  }

  function partFits(part, vehicle) {
    if (!part || !part.vehicles || !vehicle || !vehicle.make || !vehicle.model) return false;
    var year = Number(vehicle.year);
    return part.vehicles.some(function (row) {
      if (row.make !== vehicle.make || row.model !== vehicle.model) return false;
      if (!year) return true;
      return year >= row.yearStart && year <= row.yearEnd;
    });
  }

  function show(el) {
    if (el) el.hidden = false;
  }

  function setSpec(name, value) {
    var row = root.querySelector('[data-spec="' + name + '"]');
    if (!row) return;
    if (!value) {
      row.hidden = true;
      return;
    }
    var dd = row.querySelector("dd");
    if (dd && !dd.classList.contains("variant-sku")) dd.textContent = value;
    if (dd && dd.classList.contains("variant-sku") && !dd.textContent.trim()) dd.textContent = value;
    row.hidden = false;
  }

  function categoryForSlot(slot) {
    var match = CATEGORIES.filter(function (cat) {
      return cat.slots.indexOf(slot) !== -1;
    })[0];
    return match ? match.name : "";
  }

  function flattenThumbs() {
    var row = root.querySelector("[data-b1p-thumb-row]");
    if (!row || !window.jQuery) return;
    try {
      var $row = window.jQuery(row);
      if ($row.hasClass("slick-initialized")) $row.slick("unslick");
    } catch (err) {}
  }

  function bindThumbs() {
    var scroller = root.querySelector("[data-b1p-thumb-row]");
    var prev = root.querySelector("[data-b1p-thumb-prev]");
    var next = root.querySelector("[data-b1p-thumb-next]");
    if (prev && scroller) {
      prev.addEventListener("click", function () {
        scroller.scrollBy({ left: -180, behavior: "smooth" });
      });
    }
    if (next && scroller) {
      next.addEventListener("click", function () {
        scroller.scrollBy({ left: 180, behavior: "smooth" });
      });
    }
  }

  function splitDescription() {
    var source = root.querySelector("[data-b1p-details]");
    if (!source) return;
    var map = {
      installation: root.querySelector('[data-b1p-acc="installation"] .b1p-acc__body'),
      shipping: root.querySelector('[data-b1p-acc="shipping"] .b1p-acc__body'),
      warranty: root.querySelector('[data-b1p-acc="warranty"] .b1p-acc__body')
    };
    var current = null;
    Array.prototype.slice.call(source.childNodes).forEach(function (node) {
      var text = (node.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
      var heading = node.nodeType === 1 && text.length > 0 && text.length < 80;
      if (heading) {
        if (text.indexOf("install") !== -1) current = "installation";
        else if (text.indexOf("shipping") !== -1) current = "shipping";
        else if (text.indexOf("disclaimer") !== -1 || text.indexOf("warranty") !== -1) current = "warranty";
        else if (text.indexOf("payment") !== -1) current = null;
        else current = null;
      }
      if (current && map[current]) map[current].appendChild(node);
    });
    ["installation", "warranty"].forEach(function (key) {
      var body = map[key];
      var item = root.querySelector('[data-b1p-acc="' + key + '"]');
      if (item && body && body.textContent.trim()) item.hidden = false;
    });
  }

  function benefitLines() {
    var fromMeta = [];
    var meta = document.getElementById("B1pBenefits-" + root.getAttribute("data-section-id"));
    if (meta) {
      try {
        var parsed = JSON.parse(meta.textContent || "null");
        if (Array.isArray(parsed)) fromMeta = parsed.map(String).filter(Boolean);
      } catch (err) {}
    }
    if (fromMeta.length) return fromMeta.slice(0, 3);
    var details = root.querySelector("[data-b1p-details]");
    if (!details) return [];
    var skip = /^(model|compatibility|material|finish|installation|package includes)\b/i;
    return Array.prototype.slice
      .call(details.querySelectorAll("li"))
      .map(function (li) {
        return li.textContent.replace(/\s+/g, " ").trim();
      })
      .map(function (text) {
        var label = text.split(":")[0].trim();
        return skip.test(label) ? "" : label;
      })
      .filter(function (label) {
        return label && label.length > 2 && label.length < 42;
      })
      .slice(0, 3);
  }

  function paintPerformance(image) {
    var lines = benefitLines();
    var band = root.querySelector("[data-b1p-perf]");
    var list = root.querySelector("[data-b1p-perf-list]");
    if (!band || !list || !lines.length) return;
    list.innerHTML = lines
      .map(function (line, index) {
        return "<li><span>" + (index + 1) + "</span>" + escapeHtml(line) + "</li>";
      })
      .join("");
    if (image) {
      var visual = root.querySelector("[data-b1p-perf-visual]");
      if (visual) visual.style.backgroundImage = "linear-gradient(90deg, rgba(0,0,0,.55), rgba(0,0,0,.2)), url('" + image + "')";
    }
    show(band);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function paintUpgrades(parts, vehicle) {
    var row = root.querySelector("[data-b1p-next-row]");
    var section = root.querySelector("[data-b1p-next]");
    var title = root.querySelector("[data-b1p-next-title]");
    if (!row || !section) return;
    var present = {};
    parts.forEach(function (part) {
      if (part && part.slot) present[String(part.slot).toLowerCase()] = true;
    });
    if (title && vehicle && vehicle.model) {
      title.textContent = "Next upgrades for your " + vehicle.model;
    }
    row.innerHTML = CATEGORIES.map(function (cat) {
      var open = cat.slots.length && cat.slots.some(function (slot) { return present[slot]; });
      var sample = null;
      if (open) {
        sample = parts.filter(function (part) {
          if (cat.slots.indexOf(String(part.slot || "").toLowerCase()) === -1) return false;
          if (part.handle === handle) return false;
          if (vehicle) return partFits(part, vehicle);
          return true;
        })[0] || null;
      }
      var photo = sample && sample.image
        ? '<img src="' + escapeHtml(sample.image) + '" alt="">'
        : "";
      var status = open ? "Unlocked" : "Coming soon";
      var href = sample && sample.url ? sample.url : (open ? "/pages/garage" : "");
      var tag = href ? "a" : "div";
      var attr = href ? ' href="' + escapeHtml(href) + '"' : "";
      return (
        "<" + tag + ' class="b1p-cat' + (open ? " is-open" : "") + '"' + attr + ">" +
          '<div class="b1p-cat__photo">' + photo + "</div>" +
          '<div class="b1p-cat__name">' + escapeHtml(cat.name) + "</div>" +
          '<div class="b1p-cat__status">' + status + "</div>" +
        "</" + tag + ">"
      );
    }).join("");
    show(section);
  }

  function paintPart(part, vehicle) {
    var fits = partFits(part, vehicle);
    var label = vehicleLabel(vehicle);
    var eyebrow = root.querySelector("[data-b1p-eyebrow]");
    var category = categoryForSlot(part.slot);
    if (eyebrow && category) {
      var vendor = (eyebrow.textContent || "").split("·")[0].trim();
      eyebrow.textContent = vendor ? vendor + " · " + category : category;
    }

    var pending = root.querySelector("[data-b1p-fits-pending]");
    if (fits && label) {
      var fitsBox = root.querySelector("[data-b1p-fits]");
      var fitsVehicle = root.querySelector("[data-b1p-fits-vehicle]");
      if (fitsVehicle) fitsVehicle.textContent = label;
      show(fitsBox);
      var confirmed = root.querySelector("[data-b1p-fit-confirmed]");
      show(confirmed);
      var buildVehicle = root.querySelector("[data-b1p-build-vehicle]");
      if (buildVehicle) {
        buildVehicle.textContent = label;
        show(buildVehicle);
      }
      var heading = root.querySelector("[data-b1p-build-heading]");
      if (heading && category) heading.textContent = category + " upgrade for your build";
    } else if (pending) {
      var pendingLink = pending.querySelector("a");
      if (vehicle && label && pendingLink) {
        pendingLink.textContent = "Not confirmed for your " + label;
      }
      show(pending);
    }

    var matched = null;
    if (fits && vehicle) {
      matched = (part.vehicles || []).filter(function (row) {
        return row.make === vehicle.make && row.model === vehicle.model;
      })[0];
    }
    var primary = matched || (part.vehicles || [])[0];
    if (primary) {
      setSpec("make", primary.make);
      setSpec("model", primary.model);
      if (primary.yearStart && primary.yearEnd) setSpec("years", primary.yearStart + "–" + primary.yearEnd);
      show(root.querySelector("[data-b1p-fitcard]"));
    }
    if (SLOT_LABELS[part.slot]) setSpec("position", SLOT_LABELS[part.slot]);
    var sku = root.querySelector(".b1p-code");
    var partNo = sku && sku.textContent.trim();
    if (!partNo) {
      var details = root.querySelector("[data-b1p-details]");
      var modelMatch = details && details.textContent.match(/Model:\s*([A-Za-z0-9][A-Za-z0-9._-]{1,24})/);
      if (modelMatch) partNo = modelMatch[1];
    }
    if (partNo) setSpec("part", partNo);

    var fitCopy = root.querySelector("[data-b1p-fit-copy]");
    var fitAcc = root.querySelector('[data-b1p-acc="fitment"]');
    if (fitCopy && part.vehicles && part.vehicles.length) {
      fitCopy.innerHTML = "<ul>" + part.vehicles.map(function (row) {
        var years = row.yearStart && row.yearEnd ? " (" + row.yearStart + "–" + row.yearEnd + ")" : "";
        return "<li>" + escapeHtml((row.make || "") + " " + (row.model || "") + years) + "</li>";
      }).join("") + "</ul>";
      show(fitAcc);
    }

    var extra = (part.images && part.images[1]) || part.image || "";
    paintPerformance(extra);
  }

  fetch(catalogUrl)
    .then(function (res) { return res.json(); })
    .then(function (data) {
      var parts = data.parts || [];
      var part = parts.filter(function (row) { return row.handle === handle; })[0] || null;
      var vehicle = savedVehicle(readProfile());
      paintUpgrades(parts, vehicle);
      if (part) paintPart(part, vehicle);
      else paintPerformance("");
    })
    .catch(function () {});

  splitDescription();
  bindThumbs();
  window.setTimeout(flattenThumbs, 400);
})();
